import { z } from "zod";

// no eval
z.config({ jitless: true });
